// Database migrations for IndexedDB schema changes
import { LOG_CATEGORIES, logService } from '@/services/logService'

/**
 * Database version constant used throughout the application
 */
// Version 6 existed in earlier development builds without queue-owner metadata.
export const DB_VERSION = 7

/**
 * IndexedDB Migration Handler
 * Handles database schema changes between versions
 */
export class IndexedDBMigrations {
  /**
   * Apply migrations based on the old and new version
   */
  static async applyMigrations(
    db: IDBDatabase,
    oldVersion: number,
    newVersion: number,
  ): Promise<void> {
    logService.info(
      LOG_CATEGORIES.DATABASE,
      `Migrating IndexedDB from version ${oldVersion} to ${newVersion}`,
      {
        oldVersion,
        newVersion,
      },
    )

    // Future migrations can be added here
    // Example: if (oldVersion < 6 && newVersion >= 6) { ... }
  }

  /**
   * Check if a migration is needed based on current database version
   */
  static isMigrationNeeded(currentVersion: number): boolean {
    return currentVersion < DB_VERSION
  }

  /**
   * Get the target database version
   */
  static getTargetVersion(): number {
    return DB_VERSION
  }
}
